module.exports = "./dist/assets/images/7f650692128199176714307e065f61e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/background-appmenu.jpg
// module id = ./assets/images/background-appmenu.jpg
// module chunks = 0